const deviceGrid = {
  margin: `0`,
  gutter: `16px`,
}

const grid = {
  desktop: deviceGrid,
  tablet: deviceGrid,
  mobile: deviceGrid,
}

export default grid
